
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic/lookup",
      function () {
        return require("private-next-pages/traffic/lookup/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic/lookup"])
      });
    }
  